import { render, staticRenderFns } from "./purchasesOrderEdit_v1.vue?vue&type=template&id=f4ce8550&scoped=true&"
import script from "./purchasesOrderEdit_v1.vue?vue&type=script&lang=js&"
export * from "./purchasesOrderEdit_v1.vue?vue&type=script&lang=js&"
import style0 from "./purchasesOrderEdit_v1.vue?vue&type=style&index=0&id=f4ce8550&lang=less&scoped=true&"
import style1 from "./purchasesOrderEdit_v1.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ce8550",
  null
  
)

component.options.__file = "purchasesOrderEdit_v1.vue"
export default component.exports